<template>
  <div>
    <el-steps :active="step" align-center finish-status="success">
      <el-step title="Details"></el-step>
      <el-step title="Products"></el-step>
      <el-step title="Additional Questions"></el-step>
      <el-step title="Saleable Items"></el-step>
      <!-- <el-step title="Discounts"></el-step> -->
    </el-steps>
    <div class="app-content-panel">
      <Details v-if="step === 0" :value="membership" @update-obj="updateObj" ref="membership" isCreate />
      <products v-if="step === 1" :value="membership" @update-obj="updateObj" ref="membership" isCreate />
      <additional-qs v-if="step === 2" :value="membership" @update-obj="updateObj" ref="membership" isCreate />
      <saleable-items v-if="step === 3" :value="membership" @update-obj="updateObj" ref="membership" isCreate />
      <!-- <date-range-discount v-if="step === 4" :value="membership" :memberTypes="memberTypes" @update-obj="updateObj" ref="membership" isCreate /> -->
      <el-row class="mt-10">
        <el-divider></el-divider>
        <el-row :span="24" class="d-flex" :gutter="20">
          <el-col :span="12" class="leftBtnSection d-flex">
            <el-button @click="cancel" class="cancelBtn">Cancel</el-button>
            <el-button @click="back">Back</el-button>
          </el-col>
          <el-col :span="12">
            <el-button type="primary" class="btn-highlight bottomBtn" @click.prevent="next">
              {{ step === 3 ? 'Done' : 'Next' }}
            </el-button>
          </el-col>
        </el-row>
      </el-row>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Details from './components/EMSDetails.vue';
import Products from './components/EMSProducts.vue';
import AdditionalQs from './components/EMSAdditionalQs.vue';
import SaleableItems from './components/EMSSaleableItems.vue';
// import DateRangeDiscount from './components/EMSDateRangeDiscounts.vue';

export default {
  components: {
    Details,
    Products,
    AdditionalQs,
    SaleableItems,
    // DateRangeDiscount
  },
  data() {
    return {
      membership: {
        name: undefined,
        description: '',
        entityType: undefined,
        entityId: undefined,
        startDate: undefined,
        endDate: undefined,
        regoStartDate: undefined,
        regoEndDate: undefined,
        isActive: undefined,

        products: [],
        additionalQs: [],
        saleableItems: [],
        // discounts: [],
        entities: [],
        meta: {
        }
      },
      step: 0,
      memberTypes: [],
    };
  },
  mounted() {
    this.$store.commit('loading', true);
    this.$http.get('assemble/api/v1/admin/nationals/member-types').then((response) => {
      this.memberTypes = response.data.data;
      this.$store.commit('loading', false);
    }).catch((err) => {
      this.$store.commit('loading', false);
      this.$message.error(err.response.data.message);
    });
  },
  methods: {
    updateObj(val, step = 1) {
      _.assign(this.membership, val);
      if (this.step === 3 && step === 1) {
        this.$store.commit('loading', true);
        this.$http.post('/assemble/api/v1/admin/entity-memberships', this.membership).then(() => {
          this.$router.push({ name: 'entity-memberships.list' });
          this.$store.commit('loading', false);
        }).catch((e) => {
          this.$message.error(e.response.data.message);
          this.$store.commit('loading', false);
        });
      } else this.step += step;
    },
    cancel() {
      this.$router.push({ name: 'entity-memberships.list' });
    },
    back() {
      if (this.step === 0) this.$router.push({ name: 'entity-memberships.list' });
      else this.$refs.membership.updateObj(-1);
    },
    next() {
      this.$refs.membership.updateObj(1);
    }
  }
};
</script>

<style lang="scss" scoped>
.app-content-panel{
  padding: 20px;
  border: 0.5px solid rgba(45, 58, 69, 0.3);
  box-shadow: 0px 3px 6px rgba(233, 233, 233, 0.5);
  border-radius: 3px;
  background-color: #FFFFFF;
  box-shadow: $boxShadow;
  border: $border;
  border-radius: $borderRadius;
}
.leftBtnSection {
  justify-content: space-between;
}
::v-deep .el-select__input {
  border: none !important;
  box-shadow: none !important;
  cursor: pointer !important;
}
</style>
